import React from 'react';

import cs from 'classnames';
import {Link} from 'react-router';
import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
} from 'reactstrap';

import {DOCUMENT_CREATE_PAGE_URL} from 'app/urls';
import {gt} from 'app/utils/i18n';
type Props = {
  selectedFolderHashid?: string;
  invisible: boolean;
  canAddFolder: boolean;
  canCreateDocument: boolean;
  canAddExistingDocument: boolean;
  onNewFolderClick: () => void;
  onAddExistingDocumentClick: () => void;
};
export function DocumentsAddButton({
  selectedFolderHashid,
  invisible,
  canAddFolder,
  canCreateDocument,
  canAddExistingDocument,
  onNewFolderClick,
  onAddExistingDocumentClick,
}: Props) {
  // do not show the button if there are no available actions
  if (!canAddExistingDocument && !canAddFolder && !canCreateDocument) {
    return null;
  }

  return (
    <UncontrolledDropdown
      className={cs('tour-create-button', {
        invisible,
      })}
    >
      <DropdownToggle caret color="primary" className="btn-sm">
        <i className="fas fa-plus-circle mr-1" />
        {selectedFolderHashid != null ? gt('Add to Folder') : gt('Add')}
      </DropdownToggle>
      <DropdownMenu right>
        {canAddFolder ? (
          <DropdownItem
            tag="button"
            className="btn-sm btn-link btn"
            onClick={onNewFolderClick}
          >
            {gt('New Folder')}
          </DropdownItem>
        ) : null}
        {canCreateDocument ? (
          <DropdownItem
            tag={Link}
            className="btn-sm btn-link"
            to={
              DOCUMENT_CREATE_PAGE_URL +
              (selectedFolderHashid != null
                ? `?folder=${selectedFolderHashid}`
                : '')
            }
          >
            {gt('New Document')}
          </DropdownItem>
        ) : null}
        {canAddExistingDocument ? (
          <DropdownItem
            tag="button"
            className="btn-sm btn-link btn"
            onClick={onAddExistingDocumentClick}
          >
            {gt('Existing Document')}
          </DropdownItem>
        ) : null}
      </DropdownMenu>
    </UncontrolledDropdown>
  );
}
